import styled from 'styled-components';

export const Container = styled.div`
    z-index: 1000;
    display: block;
    overflow: hidden;
    position: fixed;

    // height: calc(100vh + 2px);
    width: 50vw;
    left: 18px;
    bottom: 24px;

    @media screen and (max-width: 767px) {
        width: 100vw;
        border-right: unset;
        display: none;
    }
`

export const Content = styled.div`
    overflow: hidden;
    /* width: 100%; */
    // max-width: 64%;
    z-index: 999;

    /* background: green; */
    /* position: absolute; */
    /* bottom: 0; */
    height: calc(100% - 18px);

    padding-right: 14px;
    padding-left: 14px;
    padding-top: 16px;
    /* padding-top: 15%; */
    padding-bottom: 14px;
    pointer-events: none;
    font-family: 'Verdana';
    font-size: 11.5px;
    text-align: left;

    background: ${props => props.theme.bg};
    border: 1px solid ${props => props.theme.primary};
    
    @media screen and (max-height: 640px) {
        display: none;
    }
`

export const Logo = styled.div`
    width: 18px;
    height: 18px;
    background-image: url("logo.png");
    background-size: cover;
    border: 1px solid ${props => props.theme.border};
`

export const Name = styled.div`
    display: flex;
    line-height: 100%;
    /* position: fixed; */
    /* left: 12px; */
    /* top: 14px; */
    
    /* padding-top: 22px; */
    // padding-bottom: 6px;
    /* padding-bottom: 12%; */

    color: ${props => props.theme.primary};
    font-size: 32px;
    font-weight: 300;
    /* letter-spacing: 0.25px; */
`

export const Divider = styled.div`
    z-index: -1;
    position: fixed;
    height: 45vh;
    width: 1px;
    right: 42.5%;
    border-left: 1px solid ${props => props.theme.primary};
`

export const Styled0 = styled.a`
    /* display: flex;  */
    /* width: 100%; */
    color: ${props => props.theme.secondary};;
    font-size: 14px;
    line-height: 138%;
    /* padding-bottom: 8px; */
`

export const Styled1 = styled.span`
    display: flex; 
    width: 100%;
    color: ${props => props.theme.secondary};;
    font-size: 14px;
    line-height: 138%;
    padding-bottom: 14px;
`

export const Styled2 = styled.div`
    display: flex;
    padding-top: 20px;
    width: 90%;
    /* margin-top: 18px; */
    
    color: ${props => props.theme.primary};;
    font-size: 19px;
    line-height: 131%;
`

export const Styled3 = styled.div`
    // position: absolute;
    /* right: 12px; */
    // bottom: 13px;
    /* max-width: calc(25% + 12px); */
    /* width: calc(50% - 24px); */
    padding-top: 18px;
    
    /* text-align: right; */
    font-size: 11.5px;
    line-height: 133%;
    opacity: 1;

    color: ${props => props.theme.primary};


    /* border: 1px solid blue; */
`

export const Bottom = styled.div`
    // position: absolute;
    // padding-left: 12px;
    /* padding-right: 50%; */
    // bottom: 12px;
    /* width: 100%; */
    // right: 15px;
    /* background: green; */

    // text-align: right;
    overflow: hidden;
    z-index: 997;
`

export const Close = styled.p`
    z-index: 999;
    position: absolute;
    bottom: 0px;
    // right: 14px;

    font-family: 'Verdana';
    font-size: 11.5px;
    color: ${props => props.theme.primary};

    width: 112px;
    padding: 4px 4px 3px 4px;

    border: 1px solid ${props => props.theme.primary};
    background: ${props => props.theme.bg};

    &:hover {
        cursor: pointer;
        // text-decoration: underline;
        color: ${props => props.theme.bg};
        background: ${props => props.theme.primary};
    }
`

export const Side = styled.div`
    z-index: 999;
    height: 7.5vw;
    width: 15.7vw;
    position: fixed;
    font-size: 8vw;
    letter-spacing: -.3vw;
    bottom: 7.5vh;
    left: 88.25vw;
    /* border: 1px solid black; */
    transform: rotate(90deg);

    @media screen and (max-width: 768px) {
        display: none;
    }    
`

export const Desc = styled.p`
    /* color: black; */
    font-family: SpaceMono;
    font-size: 1rem;
    line-height: 110%;
    pointer-events: none;
`

export const Resume = styled.div`
    overflow: hidden;
    /* position: absolute; */
    width: 100%;
    /* height: ; */
    /* left: 0.5rem; */

    /* padding-left: .85rem; */
    /* padding-top: -3rem; */
    padding-right: .85rem;
    font-size: 1.6rem;
    /* cursor: pointer; */
    border-bottom: 1.5px solid white;

    &:hover {
        background: black;
        background: ${props => props.theme.primary};
        color: white;        
        /* transition: 0.2s all ease-in-out; */
    }
`

export const ProfileContainer = styled.div`
    /* position: fixed; */
    /* margin-top: 1rem; */
    /* margin-left: 2.5rem; */
    /* margin-right: 2rem; */
    /* margin-top: 2.35rem; */
    display: block;
    width: calc(20vw - 1.9rem);
    width: 100%;
    height: 37.5%;

    border-bottom: 1px solid ${props => props.theme.border};;
    /* width: 100%; */
    overflow: hidden;

    img {
        display: block;
    }

    @media screen and (max-height: 998px) {
        display: none;
    }

    @media screen and (max-height: 1000px) {
        height: 15%;
    }
`

export const ResumeDownload = styled.div`
    /* height: 100%; */
    display: flex;
    align-items: center;
    float: none;
    /* width: fill; */
    text-decoration: none;
    /* padding-left: .85rem; */
    /* padding-right: .85rem; */
    padding: .85rem;
    margin-top: 1rem;
    border: 1px solid black;
    border-radius: 70px;
    font-size: 1.5rem;
    /* cursor: pointer; */

    &:hover {
        background: black;
        color: white;        
        /* transition: 0.2s all ease-in-out; */
    }
`

export const ImageSide = styled.div` 
    overflow: hidden;
    position: absolute;
    display: block;
    width: 40vw;
    z-index: 0;
    /* left: 51vw; */
    left: 6rem;
    bottom: -80vh;
    opacity: 1;
    /* transition: 0.5s all ease-in-out; */
    border: 3px solid black;

    /* &:hover {
        display: none;
    } */
    
    ${Resume}:hover & {
       bottom: 2rem;
    }

    @media screen and (max-width: 768px) {
        /* width: 96vw; */
        width: 40vw;
        height: 40vw;
        left: 0.5rem;
    }
`

export const Social = styled.a`
    display: list-item;
    // z-index: 990;
    // width: 100%;

    overflow: hidden;

    // padding-top: 4px;
    /* font-family: 'SS3'; */
    font-family: 'Verdana';
    font-size: 11.5px;
    // font-weight: 800;

    color: ${props => props.theme.primary};;
    text-decoration: none;
    border: 1px solid ${props => props.theme.primary};

    &:hover {
        text-decoration: underline;
        cursor: pointer;
    }

    &:hover {
        /* opacity: 0.9; */
        cursor: pointer;
        color: ${props => props.theme.bg};
        background: ${props => props.theme.primary};
    }

`